// extracted by mini-css-extract-plugin
export default {"Avatar":"UserProfileAvatar_Avatar__4eJfZ","Red":"UserProfileAvatar_Red__xnbQq","Dark":"UserProfileAvatar_Dark__T-dcY","Light":"UserProfileAvatar_Light__Y67p+"};